import { type FC, memo, useMemo } from 'react';
import Image from '../../../../../../shared/components/Image';
import type { CampaignBadgeStyles } from './css/base/CampaignBadg';
import { useCampaignDataAttributes, useCampaignCardStyles, useCampaignTypeContext } from 'features/campaigns';
import originalHasManyStyles from './css/hasManyStyles.module.css';
import './css/base/CampaignBadge.base.module.css';

const CampaignBadge: FC<{variant?: string}> = ({ variant }) => {
  // Only rendered in card/panel variants, which are always under a section provider.
  const campaignType = useCampaignTypeContext();
  const { getCampaignBadgeStyles } = useCampaignCardStyles();
  const dataAttributes = useCampaignDataAttributes({
    campaignType,
    additionalProps: { 'data-variant': variant }
  });
  const hasMany = dataAttributes['data-has-many'];

  const campaignBadgeStyles: CampaignBadgeStyles = useMemo(() => getCampaignBadgeStyles(), [getCampaignBadgeStyles]);
  const hasManyStyles = originalHasManyStyles as unknown as CampaignBadgeStyles;

  const badgeSrc = `/campaigns/icons/badgePrizePool_${campaignType}`;

  return (
    <div
      className={`${campaignBadgeStyles.wrapper} ${hasMany ? hasManyStyles.wrapper : ''}`}
      {...dataAttributes}
    >
      <Image src={badgeSrc} loading="eager" className={`${campaignBadgeStyles.image} ${hasMany ? hasManyStyles.image : ''}`} />
    </div>
  );
};

export default memo(CampaignBadge);
